import { FC, useCallback, useEffect, useState } from "react";
import cn from "classnames";
import Text from "antd/es/typography/Text";
import { Button } from "antd";
import { InvisibleSmartCaptcha } from "@yandex/smart-captcha";
import { resendCode } from "../../../store/actions/registrationAction";
import { useAppDispatch, useAppSelector } from "../../../store";
import { SendToEnum } from "../../../types/types";
import { tabsNamesKeys } from "../Registration.models";
import styles from "./styles.module.css";

export interface ICounterProps {
  setStep(step: tabsNamesKeys): void;
}

const Counter: FC<ICounterProps> = ({ setStep }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [resendCount, setResendCount] = useState<number>(0);
  const [counter, setCounter] = useState<number>(90);
  const [token, setToken] = useState<string>("");

  const dispatch = useAppDispatch();
  const { sended_to } = useAppSelector(
    ({ registrationSlice }) => registrationSlice
  );

  const handleChallengeHidden = useCallback(() => setVisible(false), []);
  const handleShowChallenge = () => setVisible(true);

  const padTime = (time: number): string => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    if (token !== "") {
      sendSmsConfirm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    let timer: number;
    if (counter > 0) {
      timer = window.setTimeout(() => setCounter(counter - 1), 1000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter]);

  const sendSmsConfirm = () => {
    setCounter(90);
    setResendCount((prev) => prev++);

    dispatch(resendCode({ setStep }));
  };

  const btnTheme = cn(styles.resendBtn, {
    [styles.resendBtnActive]: counter === 0,
  });

  return (
    <div className={styles.counter}>
      {sended_to === SendToEnum.email && (
        <p className={styles.hint}>
          Не приходит письмо? Проверьте папку “Спам”.
        </p>
      )}
      {sended_to === SendToEnum.phone && resendCount >= 3 && (
        <p className={styles.hint_email}>
          Не приходит код,{" "}
          <Button type="link" className={styles.linkToEmail} onClick={setStep.bind(null, tabsNamesKeys.email)}>
            Зарегистрируйтесь по email
          </Button>
        </p>
      )}
      <div className={styles.resendWrapper}>
        <Button
          type="link"
          disabled={counter !== 0}
          className={btnTheme}
          onClick={handleShowChallenge}
        >
          Выслать повторно
        </Button>
        <span className={styles.timer}>{!!counter && `через ${format(counter)} секунд`}</span>
      </div>

      <InvisibleSmartCaptcha
        key={visible ? "captchaVisible" : "captchaHidden"}
        sitekey={`${process.env.REACT_APP_CLIENT_KEY}`}
        onSuccess={setToken}
        onChallengeHidden={handleChallengeHidden}
        visible={visible}
      />
    </div>
  );
};

export default Counter;
